import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@helpers/styleUtils';
import { Search } from 'lucide-react';

const Input = React.forwardRef(({ className, type = 'text', icon = true, ...props }, ref) => {
    return (
        <div className="relative w-full">
            <input
                type={type}
                className={cn(
                    'flex h-9 w-full rounded-md border bg-transparent px-3 pl-8 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    className,
                )}
                ref={ref}
                {...props}
            />

            {icon && (
                <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-muted-foreground/80 peer-disabled:opacity-50">
                    <Search size={16} strokeWidth={2} aria-hidden="true" />
                </div>
            )}
        </div>
    );
});
Input.displayName = 'Input';

Input.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.bool,
};

export { Input };
